import {Sync} from "../index.js";
import {syncHandler} from "../../model/index.js";

/**
 * ParentSync doesn't do much on its own. It needs someone on the outside to call `handle()` when receiving a sync
 * message from the parent instance.
 */
export default class ParentSync implements Sync {
	// Not sure why `handler` is marked as unused by eslint.
	private handlers: {[handler in syncHandler]?: (data: any) => void} = {};

	constructor() {
		console.debug("PN Data ParentSync: initializing");
	}

	handle(handler: syncHandler, data: any) {
		const fn = this.handlers[handler];
		if (fn)
			fn(data);
	}

	setHandler(handler: syncHandler, fn: (data: any) => void) {
		this.handlers[handler] = fn;
	}

	destroy(): void {
		console.debug("PN Data ParentSync: destroying");
	}

	setReconnectHandler(): void {
		// Nothing to do here since we don't expect connection errors on ParentSync
	}
}
